import { useContext } from 'react';
import type { IPackageCardContext } from './PackageCardContext';
import PackageCardContext from './PackageCardContext';

export default function usePackageContext(): IPackageCardContext {
  return useContext(PackageCardContext);
}
